/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateGuaranteeCommand } from '../models/CreateGuaranteeCommand';
import type { DeleteGuaranteeCommand } from '../models/DeleteGuaranteeCommand';
import type { GuaranteeDto } from '../models/GuaranteeDto';
import type { GuaranteeListDtoPaginatedResult } from '../models/GuaranteeListDtoPaginatedResult';
import type { GuaranteeReportDtoPaginatedResult } from '../models/GuaranteeReportDtoPaginatedResult';
import type { GuaranteeReportSubCriteriaDto } from '../models/GuaranteeReportSubCriteriaDto';
import type { GuaranteeSummaryDetailDtoPaginatedResult } from '../models/GuaranteeSummaryDetailDtoPaginatedResult';
import type { GuaranteeSummaryDto } from '../models/GuaranteeSummaryDto';
import type { UpdateGuaranteeCommand } from '../models/UpdateGuaranteeCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GuaranteesService {
    /**
     * @param pageNumber
     * @param pageSize
     * @param search
     * @param filterByBank
     * @param filterByStatus
     * @param filterByDateOfGuaranteeStart
     * @param filterByDateOfGuaranteeEnd
     * @param sortBy
     * @param sortOrder
     * @param isExpired
     * @returns GuaranteeListDtoPaginatedResult OK
     * @throws ApiError
     */
    public static getApiGuarantees(
        pageNumber?: number,
        pageSize?: number,
        search?: string,
        filterByBank?: Array<string>,
        filterByStatus?: Array<string>,
        filterByDateOfGuaranteeStart?: string,
        filterByDateOfGuaranteeEnd?: string,
        sortBy?: string,
        sortOrder?: string,
        isExpired?: boolean,
    ): CancelablePromise<GuaranteeListDtoPaginatedResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Guarantees',
            query: {
                'PageNumber': pageNumber,
                'PageSize': pageSize,
                'Search': search,
                'FilterByBank': filterByBank,
                'FilterByStatus': filterByStatus,
                'FilterByDateOfGuaranteeStart': filterByDateOfGuaranteeStart,
                'FilterByDateOfGuaranteeEnd': filterByDateOfGuaranteeEnd,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
                'IsExpired': isExpired,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public static postApiGuarantees(
        requestBody?: CreateGuaranteeCommand,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Guarantees',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns GuaranteeDto OK
     * @throws ApiError
     */
    public static getApiGuarantees1(
        id: string,
    ): CancelablePromise<GuaranteeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Guarantees/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static patchApiGuarantees(
        id: string,
        requestBody?: UpdateGuaranteeCommand,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/Guarantees/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static deleteApiGuarantees(
        id: string,
        requestBody?: DeleteGuaranteeCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Guarantees/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param formData
     * @returns string OK
     * @throws ApiError
     */
    public static postApiGuaranteesDocuments(
        id: string,
        formData?: {
            GuaranteeId?: string;
            Files?: Array<Blob>;
        },
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Guarantees/Documents/{id}',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns string OK
     * @throws ApiError
     */
    public static deleteApiGuaranteesDocuments(
        id: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Guarantees/Documents/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param selectedGuarantees
     * @param unselectedGuarantees
     * @param search
     * @param filterByBank
     * @param filterByStatus
     * @param filterByDateOfGuaranteeStart
     * @param filterByDateOfGuaranteeEnd
     * @param sortBy
     * @param sortOrder
     * @param timeZone
     * @returns binary OK
     * @throws ApiError
     */
    public static getApiGuaranteesExport(
        selectedGuarantees?: Array<string>,
        unselectedGuarantees?: Array<string>,
        search?: string,
        filterByBank?: Array<string>,
        filterByStatus?: Array<string>,
        filterByDateOfGuaranteeStart?: string,
        filterByDateOfGuaranteeEnd?: string,
        sortBy?: string,
        sortOrder?: string,
        timeZone?: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Guarantees/export',
            query: {
                'SelectedGuarantees': selectedGuarantees,
                'UnselectedGuarantees': unselectedGuarantees,
                'Search': search,
                'FilterByBank': filterByBank,
                'FilterByStatus': filterByStatus,
                'FilterByDateOfGuaranteeStart': filterByDateOfGuaranteeStart,
                'FilterByDateOfGuaranteeEnd': filterByDateOfGuaranteeEnd,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
                'TimeZone': timeZone,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param reportFor
     * @param criteriaColumn
     * @param criteriaValue
     * @param searchColumn
     * @param containValue
     * @param pageNumber
     * @param pageSize
     * @param sortBy
     * @param sortOrder
     * @returns GuaranteeReportDtoPaginatedResult OK
     * @throws ApiError
     */
    public static getApiGuaranteesReport(
        reportFor?: string,
        criteriaColumn?: string,
        criteriaValue?: string,
        searchColumn?: string,
        containValue?: string,
        pageNumber?: number,
        pageSize?: number,
        sortBy?: string,
        sortOrder?: string,
    ): CancelablePromise<GuaranteeReportDtoPaginatedResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Guarantees/report',
            query: {
                'ReportFor': reportFor,
                'CriteriaColumn': criteriaColumn,
                'CriteriaValue': criteriaValue,
                'SearchColumn': searchColumn,
                'ContainValue': containValue,
                'PageNumber': pageNumber,
                'PageSize': pageSize,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param timeZone
     * @param selectedGuarantees
     * @param unselectedGuarantees
     * @param reportFor
     * @param criteriaColumn
     * @param criteriaValue
     * @param searchColumn
     * @param containValue
     * @param sortBy
     * @param sortOrder
     * @returns binary OK
     * @throws ApiError
     */
    public static getApiGuaranteesReportExport(
        timeZone: string,
        selectedGuarantees?: Array<string>,
        unselectedGuarantees?: Array<string>,
        reportFor?: string,
        criteriaColumn?: string,
        criteriaValue?: string,
        searchColumn?: string,
        containValue?: string,
        sortBy?: string,
        sortOrder?: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Guarantees/report/export',
            query: {
                'SelectedGuarantees': selectedGuarantees,
                'UnselectedGuarantees': unselectedGuarantees,
                'ReportFor': reportFor,
                'CriteriaColumn': criteriaColumn,
                'CriteriaValue': criteriaValue,
                'SearchColumn': searchColumn,
                'ContainValue': containValue,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
                'TimeZone': timeZone,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiGuaranteesReportCriteria(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Guarantees/report/criteria',
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param type
     * @returns GuaranteeReportSubCriteriaDto OK
     * @throws ApiError
     */
    public static getApiGuaranteesReportCriteriaSubcriteria(
        type: string,
    ): CancelablePromise<Array<GuaranteeReportSubCriteriaDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Guarantees/report/criteria/{type}/subcriteria',
            path: {
                'type': type,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param filterByBank
     * @param filterByProductType
     * @param filterByCurrency
     * @param gtyAmtMin
     * @param gtyAmtMax
     * @param search
     * @returns GuaranteeSummaryDto OK
     * @throws ApiError
     */
    public static getApiGuaranteesSummary(
        filterByBank?: Array<string>,
        filterByProductType?: Array<string>,
        filterByCurrency?: Array<string>,
        gtyAmtMin?: number,
        gtyAmtMax?: number,
        search?: string,
    ): CancelablePromise<GuaranteeSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Guarantees/summary',
            query: {
                'FilterByBank': filterByBank,
                'FilterByProductType': filterByProductType,
                'FilterByCurrency': filterByCurrency,
                'GtyAmtMin': gtyAmtMin,
                'GtyAmtMax': gtyAmtMax,
                'Search': search,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param selectedGuarantees
     * @param unselectedGuarantees
     * @param filterByBank
     * @param filterByProductType
     * @param filterByCurrency
     * @param gtyAmtMin
     * @param gtyAmtMax
     * @param search
     * @returns binary OK
     * @throws ApiError
     */
    public static getApiGuaranteesSummaryExport(
        selectedGuarantees?: Array<string>,
        unselectedGuarantees?: Array<string>,
        filterByBank?: Array<string>,
        filterByProductType?: Array<string>,
        filterByCurrency?: Array<string>,
        gtyAmtMin?: number,
        gtyAmtMax?: number,
        search?: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Guarantees/summary/export',
            query: {
                'SelectedGuarantees': selectedGuarantees,
                'UnselectedGuarantees': unselectedGuarantees,
                'FilterByBank': filterByBank,
                'FilterByProductType': filterByProductType,
                'FilterByCurrency': filterByCurrency,
                'GtyAmtMin': gtyAmtMin,
                'GtyAmtMax': gtyAmtMax,
                'Search': search,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param filterByBank
     * @param productTypeId
     * @param filterByCurrency
     * @param gtyAmtMin
     * @param gtyAmtMax
     * @param search
     * @param pageNumber
     * @param pageSize
     * @returns GuaranteeSummaryDetailDtoPaginatedResult OK
     * @throws ApiError
     */
    public static getApiGuaranteesSummaryDetails(
        filterByBank?: Array<string>,
        productTypeId?: string,
        filterByCurrency?: Array<string>,
        gtyAmtMin?: number,
        gtyAmtMax?: number,
        search?: string,
        pageNumber?: number,
        pageSize?: number,
    ): CancelablePromise<GuaranteeSummaryDetailDtoPaginatedResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Guarantees/summary/details',
            query: {
                'FilterByBank': filterByBank,
                'ProductTypeId': productTypeId,
                'FilterByCurrency': filterByCurrency,
                'GtyAmtMin': gtyAmtMin,
                'GtyAmtMax': gtyAmtMax,
                'Search': search,
                'PageNumber': pageNumber,
                'PageSize': pageSize,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param filterByBank
     * @param productTypeId
     * @param filterByCurrency
     * @param gtyAmtMin
     * @param gtyAmtMax
     * @param search
     * @returns binary OK
     * @throws ApiError
     */
    public static getApiGuaranteesSummaryDetailsExport(
        filterByBank?: Array<string>,
        productTypeId?: string,
        filterByCurrency?: Array<string>,
        gtyAmtMin?: number,
        gtyAmtMax?: number,
        search?: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Guarantees/summary/details/export',
            query: {
                'FilterByBank': filterByBank,
                'ProductTypeId': productTypeId,
                'FilterByCurrency': filterByCurrency,
                'GtyAmtMin': gtyAmtMin,
                'GtyAmtMax': gtyAmtMax,
                'Search': search,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
}
